/**
 * Renders an API date for display. Always fed the **clamped** `effectiveDate`
 * Baqaal returns — never a locally computed one, or the banner would promise a
 * different date from the one the gate enforces.
 */
export const formatTermsDate = (isoDate: string): string => {
	const parsed = new Date(isoDate);

	if (Number.isNaN(parsed.getTime())) {
		return "";
	}

	return parsed.toLocaleDateString("en-GB", {
		day: "numeric",
		month: "long",
		year: "numeric",
	});
};
